var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('UIHeader',{attrs:{"critical":true}}),_vm._v(" "),_c('Nuxt'),_vm._v(" "),_c('UIFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }